module.exports = __webpack_public_path__ + "static/media/facility2.f1ef92be.png";